<template>
    <div v-if="invalidParams" class="invalid-page">
        <div class="invalid-title">参数无效</div>
        <div class="invalid-desc">活动报名分类不存在，请从活动报名菜单进入。</div>
    </div>
    <div v-else class="cons">
        <div class="indexcon">
            <banner :banner="bannerList"></banner>
        </div>
        <div class="mains">
            <div class="mainCon">
                <div class="titles flx alc jsb">
                    <div v-text="cateName" class="titleft"></div>
                    <!-- <img class="checkmopre cursor" :src="$Localimg('checkmore.png')" alt="" /> -->
                </div>

                <div class="relist flx">
                    <div class="reItem cursor" :style="(index + 1) % 4 == 0?'margin-right:0' : ''"
                        v-for="item,index in recommand" @click="toDetail(item)">
                        <div class="labelName" v-text="item.label" v-if="item.label">

                        </div>
                        <div class="reImg">
                            <img :src="$img(item.pc_avatar)" alt="" />
                        </div>
                        <div class="reInfo">
                            <div class="reName multy2" v-text="item.name">

                            </div>
                            <div class="reTitle single" v-text="item.title">

                            </div>
                            <div class="flx" style="justify-content: flex-end;margin-top: 20px;">
								<div class="rebtn" v-if="item.over_time < item.current_time" style="background: #E0E0E0 !important">
								    活动已结束
								</div>
								<div class="rebtn" v-else-if="item.bm_status == 0" style="background: #E0E0E0 !important">
								    报名已结束
								</div>
                                <div class="rebtn" v-else>
                                    马上报名
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <el-pagination layout="prev, pager, next" :page-size="20" :current-page="page" @current-change="pageChange"
                :hide-on-single-page="true" :total="totals">
            </el-pagination>

        </div>
    </div>
</template>

<script>
    import {
        getActiviesList,
        getActivityCates
    } from "@/api/index.js"
    import banner from "@/components/banner.vue"
    export default {
        components: {
            banner
        },
        data() {
            return {
                cateName: '',
                id: '',
                page: 1,
                bannerList: [],
                recommand: [],
                totals: 0,
                invalidParams: true
            }
        },
        created() {
            this.validateParams()
        },
        watch: {
            $route: {
                handler(to, from) {
                    this.validateParams(to.query)
                },
                deep: true
            }
        },
        activated() {
            this.$nextTick(() => {
                window.scrollTo(0, 0)
            })
        },
        methods: {
            validateParams(query = this.$route.query) {
                const id = query.id
                const name = query.name

                this.invalidParams = true
                if (!id || typeof name !== 'string') return

                getActivityCates().then((res) => {
                    const categories = res && res.code == 1 && res.data && res.data.icon_nav
                        ? res.data.icon_nav[0] || []
                        : []
                    const category = categories.find(item =>
                        String(item.id) === String(id) && item.name === name
                    )

                    if (!category) return

                    this.id = category.id
                    this.cateName = category.name
                    this.invalidParams = false
                    this.getList()
                })
            },
            toDetail(e) {
                let that = this
                that.$router.push({
                    path: '/signDetail', // 写路由path
                    query: {
                        id: e.id,
                        name:that.cateName
                    }
                })
            },
            pageChange() {
                this.getList()
            },
            getList() {
                let that = this
                let data = {}
                data.source = 'category'
                data.category_id = that.id
                data.page = that.page
                data.size = 20
                getActiviesList(data).then((res) => {
                    console.log(res)
                    if (res.code == 1) {
                        that.bannerList = res.data.banner
                        that.recommand = res.data.list.data
                        that.totals = res.data.list.total
                       
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .invalid-page {
        min-height: 420px;
        padding-top: 160px;
        box-sizing: border-box;
        text-align: center;
        background: #fff;
    }

    .invalid-title {
        font-size: 28px;
        color: #303133;
    }

    .invalid-desc {
        margin-top: 16px;
        font-size: 15px;
        color: #909399;
    }

    .reImg {
        width: 344px;
        height: 194px;
        overflow-y:hidden
    }

    .reImg img {
        width: 100%;
    }

    .rebtn {
        width: 104px;
        height: 36px;
        background: linear-gradient(90deg, #4A9EFF 0%, #1E7FE5 100%);
        box-shadow: 0px 2px 6px 0px rgba(30, 127, 229, 0.25);
        border-radius: 18px;
        font-size: 14px;
        color: #FFFFFF;
        text-align: center;
        line-height: 36px;
    }

    .reTitle {
        font-weight: 500;
        font-size: 14px;
        color: #9CA3AF;
        margin-top: 10px;
    }

    .reInfo {
        box-sizing: border-box;
        padding: 20px;
        text-align: left;
    }

    .reName {
        height: 48px;
        line-height: 24px;
        width: 100%;
        font-weight: 600;
        font-size: 16px;
        color: #000000;
    }

    .relist {
        flex-wrap: wrap;
        box-sizing: border-box;
        padding-bottom: 56px;
    }

    .reItem {
        width: 344px;
        height: 372px;
        background: #FFFFFF;
        box-shadow: 0px 4px 7px 0px rgba(0, 0, 0, 0.08);
        border-radius: 12px;
        margin-bottom: 28px;
        overflow: hidden;
        position: relative;
        margin-right: 28px;
    }

    .mainCon {
        width: 1460px;
        margin: 0 auto;
        box-sizing: border-box;
        padding-top: 56px;
    }

    .mains {
        width: 100%;
        background: #fff;
    }

    .titles {
        margin-bottom: 27px;
    }

    .checkmopre {
        width: 64px;
        /* height: 17px; */
    }

    .titleft {
        font-weight: 600;
        font-size: 30px;
        color: #000;
    }
</style>
